/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Oct 24 2023
 **/

import dayjs from "dayjs";
import { memo } from "react";

import { Divider, Row, Typography } from "@/frameworks/designStuff/components";
import { ChronoUtils } from "@/frameworks/libraries/utilities";

function DateDescriptor({
	timestamp1,
	timestamp2,
	isFirstMessage,
	isCreate = true
}: {
	timestamp1: number;
	timestamp2: number;
	isFirstMessage: boolean;
	isCreate?: boolean;
}) {
	if (!isCreate) {
		return null;
	}

	if (isFirstMessage) {
		return (
			<Row.li css={{ padding: "0 16px", width: "100%" }}>
				<Divider type="roundedText">
					<Typography typoColor="neutral_60_100" typoSize="Body5">
						{ChronoUtils.formatPolicyDateOnly(timestamp1 || 0)}
					</Typography>
				</Divider>
			</Row.li>
		);
	}
	if (dayjs(timestamp1).isSame(timestamp2, "days")) return null;
	return (
		<Row.li css={{ padding: "0 16px", width: "100%" }}>
			<Divider type="roundedText">
				<Typography typoColor="neutral_60_100" typoSize="Body5">
					{ChronoUtils.formatPolicyDateOnly(timestamp1 || 0)}
				</Typography>
			</Divider>
		</Row.li>
	);
}

const result = memo(DateDescriptor);
result.displayName = "DateDescriptor";
export default result;
